export default __webpack_public_path__ + "static/media/wrong_location_black_48dp.5f761ae4.svg";